
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/[docId]",
      function () {
        return require("private-next-pages/legal/[docId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/[docId]"])
      });
    }
  